import countdown from 'jquery-countdown';

export default function countdownTimer() {
    $('.sales-card-big [data-countdown], .section-sale__column [data-countdown]').each(function() {
        let $this = $(this),
            finalDate = $(this).data('countdown');

        $this.countdown(finalDate, function(event) {

            if($('html').attr('lang') === 'ru') {
                $this.html(event.strftime(''
                    + '<span>%D</span>д : '
                    + '<span>%H</span>ч : '
                    + '<span>%M</span>м : '
                    + '<span>%S</span>с'));
            } else {
                $this.html(event.strftime(''
                    + '<span>%D</span>д : '
                    + '<span>%H</span>г : '
                    + '<span>%M</span>хв : '
                    + '<span>%S</span>с'));
            }
        });
    });

    $('.sales-card [data-countdown]').each(function() {
        let $this = $(this),
            finalDate = $(this).data('countdown');

        $this.countdown(finalDate, function(event) {

            $this.html(event.strftime(''
                + '<span>%D</span>д'));
        });
    });
}